export default function Listitem({text}){
    // console.log("list item has been called")
     return<li>{text}</li>
 }
